<template>
  <div class="GlobalFormDemo">
    <GlobalForm :init-data="initData" :needBtnLoading="true" :form-item-list="formItemList" :inline="true"
      :labelWidth="90" round @handleConfirm="handleConfirm" confirmBtnName="查询">
      <el-form-item class="el_from" label="订单号" slot="orderNo" style="margin:0" label-width="65px">
        <el-input v-model="orderNo" clearable placeholder="请输入订单号查询"></el-input>
      </el-form-item>
      <el-form-item class="el_from" label="回收商名称" slot="operationSelect" style="margin:0">
        <el-select v-model="merchantId" placeholder="请选择回收商" filterable clearable>
          <el-option v-for="item in shanpsSelectList" :key="item.merchantId" :label="item.merchantName"
            :value="item.merchantId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item  class="el_from" label="门店商名称" slot="companyId" style="margin-left:5px">
        <el-select v-model="companyId" placeholder="请选择门店商" filterable clearable>
          <el-option v-for="item in InquirySelectList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item class="el_from" label="费用类型" slot="accountNo" style="margin:0">
        <el-select v-model="accountNo" placeholder="请选择" clearable @change="handleChangeAccountNos">
          <el-option v-for="item in modeList" :key="item.value" :label="item.value" :value="item.key"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="el_from" label="账单类型" slot="opt" style="margin:0">
        <el-select v-model="opt" placeholder="请选择账单类型查询" filterable clearable @change="handleChangeOpt">
          <el-option v-for="item in optList" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="el_from" label="子类型" slot="serTypeList" style="margin:0" label-width="65px">
        <el-select v-model="serType" placeholder="请选择子类型" filterable clearable>
          <el-option v-for="item in serTypeList" :key="item.key" :label="item.value" :value="item.key"></el-option>
        </el-select>
      </el-form-item>
      <el-button size="small" type="success" icon="el-icon-download" @click="clickExcel">导出账单</el-button>

    </GlobalForm>
    <el-dialog title="操作提示" :visible.sync="codeShow" :close-on-click-modal="false" width="500px" @closed="code = ''">
      <div style="font-size: 14px;margin-bottom: 20px;">
        <div style="margin-top: 10px;color: #333333;font-size: 16px;text-align: center;">是否确认导出？</div>
      </div>
      <div style="display: flex;align-items: center;margin-bottom: 10px;">
        <div style="width: 88px">动态口令：</div>
        <el-input v-model="code" placeholder="请输入谷歌动态口令"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="codeShow = false">取消</el-button>
        <el-button type="primary" :loading="isExport" @click.native="codeSubmit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
import _api from "@/utils/request";
import { http } from "@/utils/request/revenue"

export default {
  name: "Form",
  props: {
    modeList: {
      require: true,
      type: Array
    },
  },
  data() {
    return {

      startTime: "",
      endTime: "",
      day60: 30 * 24 * 3600 * 1000,
      initData: {
        entryTime: [
          moment()
            .day(moment().day())
            .format("YYYY-MM-DD 00:00:00"),
          moment().format("YYYY-MM-DD 23:59:59"),
        ],
      },
      merchantId: "",
      companyId: "",
      orderNo: "",
      accountNo: '',
      opt: "",
      serType: "",
      shanpsSelectList: [],
      InquirySelectList: [],
      serTypeList: [],
      formItemList: [
        {
          key: "entryTime",
          type: "pickerOptions",
          labelName: "账单时间",
          lableWidth: '80px',
          clearable: true,
          placeholder: "请选择时间",
          valueFormat: "timestamp",
          pickerOptions: {
            onPick: ({ maxDate, minDate }) => {
              if (minDate && this.pickerMinDate) {
                this.pickerMinDate = null;
              } else if (minDate) {
                this.pickerMinDate = minDate.getTime();
              }
            },
            disabledDate: (time) => {
              if (this.pickerMinDate) {
                return (
                  time.getTime() > this.pickerMinDate + this.day60 ||
                  time.getTime() < this.pickerMinDate - this.day60
                );
              }
              return false;
            },
          },
        },
        { slotName: 'orderNo' },
        {
          labelName: "撮合渠道",
          key: "matchId",
          type: "selectFilterable",
          placeholder: "请选择",
          lableWidth: "80px",
          clear: true,
          option: [],
          clearFun: () => false,
        },
        { slotName: 'operationSelect' },
        { slotName: 'companyId' },


        { slotName: 'accountNo' },
        { slotName: 'opt' },
        { slotName: 'serTypeList' },
      ],
      optList: [
        {
          value: "01",
          label: "入账",
        },
        {
          value: "02",
          label: "出账",
        },
      ],
      codeShow: false,
      code: "",
      isExport: false,
    };
  },
  created() {
    const params = {
      pageNum: 0,
      pageSize: 999,
    }
    _api.listSimpleMerchantView(params).then((res) => {
      if (res.code === 1) {
        this.shanpsSelectList = res.data
      }
    })
    _api.getSelectList().then((res) => {
      if (res.code === 1) {
        this.InquirySelectList = res.data
      }
    })
    // 新加：撮合渠道
    _api.getMatchChannelSelect().then((r) => {
      const index = this.formItemList.findIndex((v) => v.key === "matchId");
      const data = Array.isArray(r.data) ? r.data : [];
      this.formItemList[index].option = data.map((v) => {
        return {
          value: v.id,
          label: v.name,
        };
      });
    });
    this.handleConfirm(this.initData);
  },

  methods: {

    handleConfirm(data, cd) {
      console.log("提交了form", data);
      if (!Array.isArray(data.entryTime)) {
        (this.startTime = null), (this.endTime = null);
      } else {
        (this.startTime = moment(data.entryTime[0]).format("x")),
          (this.endTime = moment(data.entryTime[1]).format("x"));
      }
      let SeachParams = {};
      if (data) {
        SeachParams = {
          matchId: data.matchId || '',
          accountNo: this.accountNo || '',
          merchantId: this.merchantId || "",
          companyId: this.companyId || "",
          orderNo: this.orderNo || data.orderNo || "",
          opt: this.opt || "",
          serType: this.serType || "",
          startTime: this.startTime,
          endTime: this.endTime,
          pageNum: 1,
          pageSize: 10,
        };
      }
      SeachParams.disuseLoding = () => {
        if (typeof cd === 'function') {
          cd();
        }
      },
        console.log(SeachParams);
      this.$store.commit("tagsView/SEACH_PARAMS", SeachParams);
    },
    handleChangeAccountNos(val) {
      this.accountNo = val
      this.serType = ""
      http.getSerTypeList({ accountNo: this.accountNo, opt: this.opt, pageType: '04' }).then((res) => {
        if (res.code === 1) {
          this.serTypeList = res.data
        }
      })
    },
    handleChangeOpt(val) {
      this.opt = val
      this.serType = ""
      http.getSerTypeList({ accountNo: this.accountNo, opt: this.opt, pageType: '04' }).then((res) => {
        if (res.code === 1) {
          this.serTypeList = res.data
        }
      })
    },
    // 导出账单
    clickExcel() {
      this.codeShow = true
    },
    // 导出账单弹框确定
    codeSubmit() {
      if (!this.code.trim()) {
        return this.$message.error("请输入动态口令");
      }
      let SeachParams = this.$store.state.tagsView.SeachParams
      console.log(SeachParams);
      if (!SeachParams.startTime) {
        this.$message.error('请先选择账单时间（31天内）')
        return false
      }
      if ((SeachParams.endTime / 1000 - SeachParams.startTime / 1000 + 1) / 60 / 60 / 24 / 31 > 1) {
        this.$message.error('选择的账单时间超过31天，请重新选择')
        return false
      }
      this.isExport = true
      SeachParams.command = this.code
      http.exportExcel({
        pageType: '04',
        ...SeachParams
      }).then((res) => {
        const content = res;
        const blob = new Blob([content]);
        let reader = new FileReader(); // 创建读取文件对象
        reader.addEventListener("loadend", () => {
          try {
            let data = JSON.parse(reader.result);
            if (data.code === 0) {
              this.$message.error(data.msg || "服务异常");
            }
          } catch (err) {
            const fileName = "渠道撮合服务费收入账户.xlsx"
            if ("download" in document.createElement("a")) {
              // 非IE下载
              const elink = document.createElement("a");
              elink.download = fileName;
              elink.style.display = "none";
              elink.href = URL.createObjectURL(blob);
              document.body.appendChild(elink);
              elink.click();
              URL.revokeObjectURL(elink.href); // 释放URL 对象
              document.body.removeChild(elink);
            } else {
              // IE10+下载
              navigator.msSaveBlob(blob, fileName);
            }
            this.codeShow = false
          }
        });
        reader.readAsText(blob, "utf-8");

        this.isExport = false
      }).catch(err => {
        console.log("97899999");
        this.isExport = false
      });
    }



  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.GlobalFormDemo {}
</style>
